<!-- <p>forgotpassword works!</p> -->


<body
  class="layout nb-layout vertical-layout vertical-menu-modern 1-column  navbar-floating footer-static bg-full-screen-image  blank-page blank-page"
  data-open="click" data-menu="vertical-menu-modern" data-col="1-column">
  <!-- BEGIN: Content-->
  <div class="app-content content" style="height:80vh;">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
      </div>

      <div class="content-body" style="margin-left:0px;">
        <section class="row flexbox-container">
          <div class="col-xl-1"></div>
          <div class="col-xl-10 col-lg-12 col-12 d-flex justify-content-center px-0" style="margin-top: 30vh;">
            <div class="col-lg-4 col-md-2 col-0"></div>

            <div class="card col-lg-4 col-md-8 col-12">
              <div class="row">

                <div class="col-lg-12 col-12 p-0">
                  <div class="card rounded-0">
                    <div class="card-header pb-2 headerbg">
                      <div class="nb-header">
                        <h6 class="mb-0 titletxt">Forgot your password</h6>
                      </div>
                    </div>
                    <p class="notetxt px-4 pt-2 pb-0 mb-0">Please enter your username and we'll
                      send you instructions on email on how to reset your password.</p>
                    <p class="notetxt px-4 pt-2 pb-0 mb-0"><small>Note: If you are admin user then kindly contact system
                        admin to reset your password.</small></p>
                    <div class="card-content">
                      <div class="card-body pt-1 mt-0">
                        <div class="text-center" id="forgotErrMsg" style="display:none; color: red;padding:0 0 20px 0;">
                        </div>

                        <form [formGroup]="forgotForm" class="login-container" (ngSubmit)="onSubmitFP()">
                          <div class="form-group">
                            <nb-form-field>
                              <input type="text" nbInput fullWidth placeholder="Code\PanNo" fieldSize="medium"
                                formControlName="code" [ngClass]="{ 'is-invalid': submitted && f.code.errors }"
                                name="code" maxlength="10" minlength="3" class="forgotInput" />
                            </nb-form-field>
                            <div *ngIf="submitted && f.code.errors" class="errorMessage">
                              <div *ngIf="f.code.errors.required">Code is required</div>
                              <div *ngIf="f.code.errors.minlength">Code should be at least 3 characters long.</div>
                            </div>
                          </div>

                          <div class="form-group">
                            <nb-form-field>
                              <input type="text" nbInput fullWidth placeholder="Username" fieldSize="medium"
                                formControlName="username"
                                [ngClass]="{ 'is-invalid': submitted && f.username.errors }" class="forgotInput" />
                            </nb-form-field>
                            <div *ngIf="submitted && f.username.errors" class="errorMessage">
                              <div *ngIf="f.username.errors.required">Username is required</div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="float-md-left mb-1 col-md-6 col-6">
                              <button (click)="backToLogin()" class="btn btn-primary back-btn btn-inline">Back
                                to Login</button>
                            </div>
                            <div class="float-md-right mb-1  col-md-6 col-6">
                              <!-- <a href="#" class="btn btn-primary btn-block px-75 waves-effect waves-light">Recover Password</a> -->
                              <button id="submitForgot" class="btn custom-btn float-right btn-inline" [class.disabledBtn]="loading"><nb-icon nbPrefix class="fa fa-spinner fa-spin" pack="font-awesome"></nb-icon>Recover</button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div class="login-footer">
                      <div class="divider">
                        <!-- <div class="divider-text">OR</div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-2  col-0"></div>
          </div>
          <div class="col-xl-1"></div>
        </section>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</body>
